import * as z from "zod";
import { comma_separated_field, nullable_field, timeString } from "../_helpers";

export const school_schema = z
  .object({
    name: z
      .string({ error: "Name is required" })
      .min(1, "Name is required"),
    email: z.email("Please enter a valid email"),
    notification_emails: comma_separated_field(
      z.email("One or more notification emails are invalid")
    ),
    phone: z.string({ error: "Phone is required" }),
    address_line1: z.string({ error: "Address Line 1 is required" }),
    city: z.string({ error: "City is required" }),
    state: z.string({ error: "State is required" }),
    zip: z.string({ error: "Zip is required" }),
    district: nullable_field(z.string()),
    address_line2: nullable_field(z.string()),
    county: nullable_field(z.string()),
    full_day_start: nullable_field(timeString("Full Day Start")),
    full_day_end: nullable_field(timeString("Full Day End")),
    morning_end: nullable_field(timeString("Morning End")),
    afternoon_start: nullable_field(timeString("Afternoon Start")),
    default_pay_rate: nullable_field(
      z.coerce
        .number({ error: "Default Pay Rate is not a valid number" })
        .nonnegative("Default Pay Rate cannot be negative")
    ),
    logo_url: nullable_field(z.url("Logo URL is not a valid URL")),
  })
  .refine(
    (d) =>
      d.full_day_start == null ||
      d.full_day_end == null ||
      d.full_day_end > d.full_day_start,
    {
      path: ["full_day_end"],
      message: "Full Day End must be after Full Day Start",
    }
  )
  .refine(
    (d) =>
      d.full_day_start == null ||
      d.morning_end == null ||
      d.morning_end > d.full_day_start,
    {
      path: ["morning_end"],
      message: "Morning End must be after Full Day Start",
    }
  )
  .refine(
    (d) =>
      d.full_day_end == null ||
      d.afternoon_start == null ||
      d.afternoon_start < d.full_day_end,
    {
      path: ["afternoon_start"],
      message: "Afternoon Start must be before Full Day End",
    }
  );
